import { AvpCustomAdaptor } from './../../../base/shared/syncfusion/avp-custom-adaptor';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ServiceClientsAdministrationService } from './service-clients-administration.service';
import { Component, OnInit } from '@angular/core';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';

import { SearchFieldComponent } from '../../../base/shared/search-field/search-field.component';

@Component({
  selector: 'app-service-clients-administration',
  templateUrl: './service-clients-administration.component.html',
  styleUrls: ['./service-clients-administration.component.scss'],
  imports: [SearchFieldComponent, GridModule, TranslateModule],
  providers: [ServiceClientsAdministrationService]
})
export class ServiceClientsAdministrationComponent extends GridBaseComponent<any> implements OnInit {

  constructor(
    private serviceClientsAdministrationService: ServiceClientsAdministrationService,
    translateService: TranslateService,
    private spinnerService: SpinnerService
  ) {
    super(null, translateService, serviceClientsAdministrationService);
    // Read-only grid — no commands
    this.gridCommands = [];
    this.searchOptions = { fields: ['name', 'address', 'city', 'email'] };
    this.editSettings = {
      allowEditing: false,
      allowAdding: false,
      allowDeleting: false,
      mode: 'Dialog',
      showDeleteConfirmDialog: false,
    };
  }

  public ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.serviceClientsAdministrationService, this.spinnerService),
    });
  }

  protected initializeEditForm(data: any): void {
    // Read-only — no edit form needed
  }

  protected getEditDialogTitleParams(rowData: any): object {
    return {};
  }
}
